import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-seo-managers',
  templateUrl: './hire-seo-managers.component.html',
  styleUrls: ['./hire-seo-managers.component.css']
})
export class HireSeoManagersComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-seo-managers/hire-seo-managers.component.ts